export default __webpack_public_path__ + "static/media/icon-fleches-vs.be28f5ee.svg";